module.exports = __webpack_public_path__ + "static/media/special-stone-black.b91e1e9d.svg";